<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">병동에서 제공되는 <br> 서비스 및 주의사항</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">준비물품</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">회진 안내</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">식사 안내</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">면회 안내 및 주의사항</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">기타사항</a>
                </li>
            </ul>
        </div>

        <!-- 대동맥 -->
        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/info-img05.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img06.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img07.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img08.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/hospitalization01-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization02-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization03-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">병동에서 제공되는 서비스 및 주의사항</h3>
            <h4 class="bullet02 type2 num1 depth">응급 시 호출 방법</h4>
            <p class="depth">응급상황 또는 간호사의 도움이 필요할 때에는 침상 옆이나 화장실과 샤워실 벽에 부착되어 있는 비상벨을 누르시면 즉시 도움을 받으실 수 있습니다.</p>

            <h4 class="bullet02 type2 num2 depth">팔찌 착용</h4>
            <p class="depth">정확한 환자 확인을 위해 환자 확인용 팔찌를 착용하셔야 하며, 이를 통하여 환자 이름 및 등록 번호를 확인하고 있습니다. 팔찌가 오염 또는 훼손된 경우 간호사실에
                알려주십시오. 즉시 교체해 드립니다.</p>

            <h4 class="bullet02 type2 num3 depth">소아환자 실종 및 유괴 예방</h4>
            <p class="depth">소아환자 실종 및 유괴 예방을 위하여 보호자께서는 소아환자와 항상 함께 계시기 바랍니다.</p>

            <h4 class="bullet02 type2 num4 depth">환자 이상징후(의식변화, 흉통, 출혈, 경련) 발견 즉시 의료진 또는 병원직원에게 알려주시기 바랍니다.</h4>

            <h4 class="bullet02 type2 num5 depth">병실 이동</h4>
            <p class="depth">같은 등급의 병실 내에서는 환자 안전 문제(투약, 채혈, 배식, 처치)등의 이유로 선호침상으로 이동이 금지되어 있습니다.</p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">준비물품</h3>
            <div class="need-item">
                <div class="need-item__text">
                    <h4 class="bullet02 type2 num1 depth">개인 준비물품</h4>
                    <p class="bullet03 depth font-main">환자 신분증(필수)</p>
                    <p class="bullet05 depth"> 본인 확인용-모바일 신분증 및 건강보험증 가능</p>
                    <p class="bullet05 depth"> 환자가 미성년자인 경우 가족관계증명서/등본 대체가능</p>
                    <p class="bullet05 depth font-sub"> 국민건강보험법 「환자 본인확인 의무화 제도」 시행(2024.5.20.)</p>
                    <p class="bullet03 depth">복용약 : 복용 중인 약처방전 또는 약명이 기재된 약봉투를 병동 간호사실에 제출</p>
                    <p class="bullet03 depth">물품 : 세면도구, 수건, 앞·뒤가 막힌 환자용 실내화(슬리퍼, 크록스 금지), 화장지, 물컵, 보호자 침구류 등 개인물품</p>
                    <h4 class="bullet02 type2 num2 depth">기타 사항</h4>
                    <p class="bullet03 depth">수술이 예정된 경우, 네일케어는 꼭 제거하여 주시기 바랍니다</p>
                    <p class="bullet03 depth">물품 : 세면도구, 수건, 앞·뒤가 막힌 환자용 실내화(슬리퍼, 크록스 금지), 화장지, 감염과 화재 및 안전사고 예방을 위해 가습기, 전기포터, 전기장판, 선풍기 등 전열기와 가열성 인화성 물질 등의 사용이 불가합니다, 보호자 침구류 등 개인물품</p>
                </div>
                <div class="need-item__img">
                    <img src="/resource/img/intensive--img01.png" alt="">
                </div>
            </div>
        </div>
        
        <div id="step3" class="step-item info">
            <h3 class="bullet01">회진 안내</h3>
            <p class="depth">오전 7시 20분 ~ 9시경에 회진이 있으며, 응급수술 등 진료과 사정에 따라 변동이 있을 수 있습니다.</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">식사 안내</h3>
            <p class="bullet04 num1 depth">아침식사는 오전 7시~8시, 점심식사는 오후 12시~1시, 저녁식사는 오후 6시~7시경에 제공되며, 사식 반입 및 푸드코트에서의 취식은
                환자치료 및 감염 예방을 위하여 제한하여 주시기 바랍니다.</p>
            <p class="bullet04 num2 depth">냉장고 음식보관 : 발효식품을 제외한 조리음식은 보관기간이 길어질 경우 변질될 우려가 있으므로 24시간까지만 보관해주시기 바랍니다.</p>
            <p class="bullet04 num3 depth">환자가 희망하는 경우 비급여식 ‘특별식’을 선택할 수 있고, 이 경우 비용은 전액 본인 부담입니다.</p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">면회 안내 및 주의사항</h3>
            <p class="bullet04 num1 depth">환자의 빠른 쾌유와 안정 및 감염예방을 위하여 면역성이 약한 13세 이하 어린이는 감염병실과 중환자실의 면회가 금지됩니다.</p>
            <p class="bullet04 num2 depth">감기 및 전염성 질환이 있는 보호자의 방문을 제한하며, 사생활보호를 원하거나 면회를 원하지 않는 경우 간호사실에 알려주시기 바랍니다.
            </p>
            <p class="bullet04 num3 depth">병문안객 관리를 위한 명부 작성 시 협조하여 주시기 바랍니다.</p>
            <p class="bullet04 num4 depth"><span class="font-main">병문안 안내 : 면회금지</span></p>
            <p class="bullet05 depth">보호자 출입증을 소지한 1인만 병동 출입 가능</p>
            <p class="bullet05 depth">환자의 안전과 감염예방을 위해 병동 면회를 제한합니다.</p>
            <p class="bullet05 depth">1층 로비 및 4층 힐링정원을 이용해 주시기 바랍니다.</p>
        </div>
        <div id="step6" class="step-item info">
            <h3 class="bullet01">기타사항</h3>
            <h4 class="bullet02 type2 num1 depth">편의시설</h4>
            <p class="depth">병동 : 공용화장실, 오물처리세척실, 샤워실, 휴게실, 자판기, 정수기, 전자레인지, 다용도실 등이 있습니다.</p>
            <p class="depth">진료비 무인수납기, 영상CD 등록기, 편의점, 은행, 카페, 푸드코트, 베이커리, 의료기기, 무인 택배함 등이 있습니다.</p>

            <h4 class="bullet02 type2 num2 depth">분리수거</h4>
            <p class="depth">사용하신 알콜솜과 거즈는 의료폐기물 전용용기에 분리수거 하시기 바랍니다.</p>

            <h4 class="bullet02 type2 num3 depth">금연</h4>
            <p class="depth">병원은 환자의 건강과 화재예방을 위하여 시설 전체가 금연구역이오니 금연에 협조하여 주시기 바랍니다.</p>

            <h4 class="bullet02 type2 num4 depth">화재 예방 및 대처방법</h4>
            <p class="depth">병실에서 휴대용 가스레인지, 선풍기, 전열기 사용 및 인화성, 가연성 물질의 반입을 삼가하여 주시기 바랍니다. 화재 발생 시 신속히 간호사에게 알리고 병원 직원의
                유도에 따라 피난전실과 비상계단을 통하여
                대피하시기 바랍니다.</p>

            <h4 class="bullet02 type2 num5 depth">산책 안내</h4>
            <p class="depth">건물 밖으로의 산책은 원칙적으로 금지합니다. 단, 담당간호사 허락 및 보호자 동행 하에 건물 4층 정원, 북문 잔디광장에서 산책이 가능합니다. 산책시 휴대전화를
                가져가시고, 오후 6시 전까지 병실로 돌아오셔야 합니다.</p>

            <h4 class="bullet02 type2 num6 depth">불만 및 고충 처리</h4>
            <p class="depth">병원을 이용 시 궁금했거나 불편했던 점, 칭찬하고 싶은 점이 있으면 1층 고객 만족실 방문, 전화, 병원 홈페이지 또는 고객의 소리함을 이용하실 수 있습니다.
            </p>

            <h4 class="bullet02 type2 num7 depth">주차 요금</h4>
            <p class="depth">병동게시판에 게시되어 있는 주차요금안내를 참조하시기 바랍니다.</p>

            <h4 class="bullet02 type2 num8 depth">분실 및 도난 주의</h4>
            <p class="depth"><span class="font-main">
                    귀중품과 현금은 병실에 보관하지 마시고,</span>
                의치, 보청기, 안경, 렌즈 등의 보조기는 검사 및 시술, 수술 시에 제거하시고
                <span class="font-main">보관에 유의하시기 바랍니다. 본인의 부주의로 인한 분실 발생 시에는 의료원에서 책임지지 않습니다.</span>
            </p>
            <div class="depth">
                <div class="bullet-wrap">
                    <span class="font-main">소지품 관리</span>
                    <!-- <ul class="bullet-list">
                        <li class="bullet-item">본인관리</li>
                        <li class="bullet-item">보호자관리</li>
                    </ul> -->
                </div>
                <p>검사 또는 처치를 위해 제거하는 경우 분실되지 않도록 주의하여 주시길 바랍니다. </p>
                <p>본인의 부주의로 인한 분실 발생 시에는 의료원에서 책임지지 않습니다.</p>

                <!-- <ul class="bullet-list type2">
                    <li class="bullet-item">틀니</li>
                    <li class="bullet-item">보청기</li>
                    <li class="bullet-item">안경</li>
                    <li class="bullet-item">시계</li>
                    <li class="bullet-item">귀걸이</li>
                    <li class="bullet-item">목걸이</li>
                    <li class="bullet-item">반지</li>
                    <li class="bullet-item">팔찌</li>
                    <li class="bullet-item">발찌</li>
                    <li class="bullet-item">열쇠</li>
                    <li class="bullet-item">지갑</li>
                    <li class="bullet-item">신발</li>
                    <li class="bullet-item">옷</li>
                    <li class="bullet-item">기타</li>
                    <li class="bullet-item">해당무</li>
                </ul> -->
            </div>


            <h4 class="bullet02 type2 num9 depth">종교시설안내</h4>
            <p class="depth">본원은 기독교 병원이며 주일예배는 일요일 오전 10시, 수요예배는 수요일 오후 5시, 어린이/청소년 예배는 목요일 오전 10시에 C관 3층 방주교회에서 있습니다.
                병동 심방, 신앙 상담, 기타 종교 상담 등의 문의는 원목상담실(02-6986-5724)로 전화하시면 가능하며, 원목상담실과 기도실은 C관 3층에 위치하고 있습니다.</p>

            <h4 class="bullet02 type2 num10 depth">각종 증명서류 발급</h4>
            <p class="depth">진단서, 의무기록 및 영상 복사 등 필요한 서류는 미리 담당의사나 간호사에게 말씀하여 주시기 바랍니다.</p>

            <h4 class="bullet02 type2 num11 depth">환자의 권리와 의무</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>환자의 권리</th>
                                <th>환자의 의무</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">진료 받을 권리</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">의료인에 대한 신뢰·존중 의무</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">알 권리 및 자기결정권</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">비밀을 보호받을 권리</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">부정한 방법으로 진료를 받지 않을 의무</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">상담·조정을 신청할 권리</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">안전한 의료환경에서 의료서비스를 제공받을 권리</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <h4 class="bullet02 type2 num12 depth mt30">진료거부 안내</h4>
            <p class="depth">환자 또는 보호자 등이 해당 의료인에 대하여 모욕죄, 명예훼손죄, 폭행죄, 업무방해죄에 해당될 수 있는 상황을 형성하여 의료인이 정상적인 의료행위를 행할 수 없도록
                한 경우 의료법과 응급 의료법을 위반하지
                않는 범위 내에서 진료를 거부(진료거부권)할 수 있습니다.</p>
            <h4 class="bullet02 type2 num13 depth">환자 또는 보호자(방문객)가 직원에게 폭력(폭언, 협박, 난동, 성폭력, 성희롱, 기물파손 등)행위로 피해를 입힌 경우 관계
                법령에 따라 처벌을 받을 수 있습니다.</h4>

        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>